import axios from "axios";
import { ADMIN_URL } from "../utils/constants";

export async function getQuestionsByIds(arrayOfIds) {
  const response = await axios.post(`${ADMIN_URL}/question/many`, {
    questions: arrayOfIds,
  });
  return response.data;
}

export async function getQuestionById(questionId) {
  const response = await axios.get(`${ADMIN_URL}/question/${questionId}`);
  return response.data;
}

export async function postVoteByQuestion(questionId, voteId) {
  const response = await axios.post(
    `${ADMIN_URL}/question/${questionId}/vote/${voteId}`,
  );
  return response.data;
}
